import React, { FC } from 'react';
import { observer } from 'mobx-react';
import Grid from 'components/UI/Grid';
import Text from 'components/UI/Text';
import { useStores } from 'stores/hooks/hooks';
import Button from 'components/UI/Button';
import { theme } from 'components/UI';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { displayFileOrDownload } from 'utils/fileHelpers';

const StyledLinkButton = styled(Button)`
  &:hover {
    background-color: transparent;
  }
`;

const Bold = styled.b``;

const PlotUploadComplete: FC = () => {
  const { resellersStore } = useStores();
  const { t } = useTranslation('plot');
  const unSelectedPlots = resellersStore.plotUploadExcel.filter(
    (el) => !el.selected,
  );

  const saveAsExcelFile = () => {
    displayFileOrDownload(
      resellersStore.invalidPlotsFileBlob,
      resellersStore.invalidPlotsFileName,
    );
  };

  return (
    <Grid>
      <Text>
        <Bold>{t('selected_plots_uploaded')}</Bold>
      </Text>
      {unSelectedPlots.length > 0 && (
        <>
          <Text>
            {t('plots_not_saved', { number: unSelectedPlots.length })}
          </Text>
          <StyledLinkButton
            variant="text"
            disableRipple
            onClick={saveAsExcelFile}
          >
            <Text textcolor={theme.color.link} fontWeight={700}>
              {t('download_file')}
            </Text>
          </StyledLinkButton>
        </>
      )}
      {unSelectedPlots.length === 0 && (
        <Text textcolor={theme.color.link} fontWeight={700}>
          {t('no_invalid_plots')}
        </Text>
      )}
    </Grid>
  );
};

export default observer(PlotUploadComplete);
